// All route path constants — never hardcode route strings in components
export const ROUTES = {
    HOME: '/',
    LOGIN: '/login',
    REGISTER: '/register',
    FORGOT_PASSWORD: '/forgot-password',
    RESET_PASSWORD: '/reset-password',
    VERIFY_OTP: '/verify-otp',
    RESTAURANTS: '/restaurants',
    RESTAURANT: (id) => `/restaurants/${id}`,
    MENU: (restaurantId) => `/restaurants/${restaurantId}/menu`,
    CART: '/cart',
    CHECKOUT: '/checkout',
    ORDERS: '/orders',
    ORDER: (id) => `/orders/${id}`,
    ORDER_TRACKING: (id) => `/orders/${id}/tracking`,
    ORDER_RECEIPT: (id) => `/orders/${id}/receipt`,
    ORDER_CHAT: (id) => `/orders/${id}/chat`,
    PROFILE: '/profile',
    UNAUTHORIZED: '/unauthorized',
    WALLET: '/wallet',
    NOTIFICATIONS: '/notifications',
    ADDRESSES: '/profile/addresses',
    PAYMENT_CALLBACK: '/payment/callback',
    FAVORITES: '/favorites',
    SEARCH: '/search',
    ORDER_DISPUTE: (id) => `/orders/${id}/dispute`,
    REFERRALS: '/referrals',
    HELP: '/help',
};
//# sourceMappingURL=routes.js.map